import { CommonModule } from "@angular/common";
import { NgModule } from "@angular/core";
import { TranslateModule } from "@ngx-translate/core";
import { SideNavBarService } from "./sidenavbar.service";
import { BpRoutingService } from "../bp-routing/bp-routing.service";


@NgModule({
    imports: [
        CommonModule,
        TranslateModule,
    ],
    providers: [
        BpRoutingService,
        SideNavBarService
    ]
  })
  export class BpSideNavbarModule { }
